import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
import LazyLoad from 'react-lazyload';
const SchoolCabinet = () => {  
  useEffect(() => {
    document.title = 'School Cabinet - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>School</li>
                    <li>School Cabinet</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container schoolcabinet"> 
                    <div className="row">
                    <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/HeadBoy.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>HENRY JOHN </h3>
                       <h4>(Head Boy)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/ViceHeadBoy.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>NAVDEEP SIWACH </h3>
                       <h4> (Vice Head Boy)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/HeadGirl.jpg"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>MRIDULA </h3>
                       <h4>(Head Girl)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/ViceHeadGirl.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>NISHU </h3>
                       <h4>(Vice Head Girl)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/DisciplineMinister-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>YOGESH </h3>
                       <h4>(Minister of Discipline)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/DisciplineMinister-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>MANYA </h3>
                       <h4> (Minister of Discipline)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/MinisterAcademic-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>YUG</h3>
                       <h4> (Minister for Academic)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/MinisterAcademic-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>YASHIKA </h3>
                       <h4> (Minister for Academic)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/EnvironmentHealth-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>NITIN </h3>
                       <h4> (Minister of Environment & Health)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/EnvironmentHealth-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>SADGI </h3>
                       <h4> (Minister of Environment & Health)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/CulturalMinister-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>GARVIT GORA </h3>
                       <h4>(Minister of Cultrual Activities)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/CulturalMinister-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>SHARDDHA</h3>
                       <h4>(Minister of Cultrual Activities)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/SportsCaptain-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>PUNIT </h3>
                       <h4>(School Sports Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/STAGESECRETART-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>GARVITA </h3>
                       <h4> (STAGE SECRETART)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/STAGESECRETARY.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>DIPANSHU </h3>
                       <h4> (STAGE SECRETARY)</h4>
                    </article>
                 </div>
                 <div className="clr"></div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/GandhiCaptain-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>JAI ADITIYA </h3>
                       <h4> (Gandhi House Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/GandhiCaptain-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>VANI </h3>
                       <h4>(Gandhi House Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/GandhiViceCaptain-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>EMILIYA </h3>
                       <h4>(Gandhi House Vice Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/GandhiViceCaptain-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>LIVAN </h3>
                       <h4>(Gandhi House Vice Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/GandhiSportsCaptain-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>PREETI </h3>
                       <h4>(Gandhi House Sports Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/GandhiSportsCaptain-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>PUNIT </h3>
                       <h4>(Gandhi House Sports Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/GandhiHousePrefect-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>KARTIK</h3>
                       <h4>(Gandhi House Prefect)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/GandhiHousePrefect-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>BHAVYA </h3>
                       <h4>(Gandhi House Prefect)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/GandhiHousePrefect-3.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>SIYA </h3>
                       <h4>(Gandhi House Prefect)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/GandhiHousePrefect-4.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>VIGNESH </h3>
                       <h4>(Gandhi House Prefect)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/RamanCaptain-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>KANISH </h3>
                       <h4> (Raman House Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/RamanCaptain-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>POORVA </h3>
                       <h4>(Raman House Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/RamanViceCaptain-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>JITAIN </h3>
                       <h4>(Raman House Vice Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/RamanViceCaptain-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>RIYA </h3>
                       <h4> (Raman House Vice Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/RamanSportsCaptain-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>AYESHA </h3>
                       <h4>(Raman House Sports Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/RamanSportsCaptain-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>RAMAN </h3>
                       <h4>(Raman House Sports Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/RamanHousePrefect-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>PRANAV </h3>
                       <h4>(Raman House Prefect)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/RamanHousePrefect-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>MANVI </h3>
                       <h4>(Raman House Prefect)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/RamanHousePrefect-3.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>ARSHIYA </h3>
                       <h4>(Raman House Prefect)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/RamanHousePrefect-4.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>SARANSH </h3>
                       <h4>(Raman House Prefect)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TeresaCaptain-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>LOKESH </h3>
                       <h4> (Teresa House Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TeresaCaptain-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>JASMINE </h3>
                       <h4> (Teresa House Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TeresaViceCaptain-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>DEVEN </h3>
                       <h4>(Teresa House Vice Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TeresaSportsCaptain-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>JAI BALODA </h3>
                       <h4> (Teresa House Sports Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TeresaSportsCaptain-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>MAHI </h3>
                       <h4>(Teresa House Sports Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TeresaSportsPrefect-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>HARSHIT</h3>
                       <h4>(Teresa House Sports Prefect)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TeresaSportsPrefect-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>HASMITA </h3>
                       <h4>(Teresa House Sports Prefect)</h4>
                    </article>
                 </div>
  
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TeresaSportsPrefect-3.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>SHUBHANKER </h3>
                       <h4>(Teresa House Sports Prefect)</h4>
                    </article>
                 </div>
  
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TeresaSportsPrefect-4.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>VAISHNAVI </h3>
                       <h4>(Teresa House Sports Prefect)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TagoreCaptain-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>NAKUL </h3>
                       <h4> (Tagore House Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TagoreViceCaptain-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>ABHISHEK </h3>
                       <h4> (Tagore House Vice Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TagoreSportsCaptain-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>ARSH</h3>
                       <h4>(Tagore House Sports Captain)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TagoreSportsPrefect-1.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>HIMANSHU </h3>
                       <h4>(Tagore House Sports Prefect)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TagoreSportsPrefect-2.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>KANISHKA </h3>
                       <h4>(Tagore House Sports Prefect)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TagoreSportsPrefect-3.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>PIYUSH </h3>
                       <h4>(Tagore House Sports Prefect)</h4>
                    </article>
                 </div>
                 <div className="col-lg-2 col-md-4 col-sm-6">
                    <article>
                       <LazyLoad>
                          <img
                          src="https://webapi.entab.info/api/image/SFXH/public/images/cabinet/TagoreSportsPrefect-4.JPG"
                          alt="sfxhisar" className="img-fluid mx-auto d-block"/></LazyLoad>
                       <h3>YASHIKA </h3>
                       <h4>(Tagore House Sports Prefect)</h4>
                    </article>
                 </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default SchoolCabinet;
